import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { chrysalisConfig } from '../chrysalis-config';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/throttleTime';



export class ChSidebarComponent implements OnInit {

   menuList: any[];
   isFixed = true;
  isCollapse: any;
  lockState = true;
  resizeSub: Subject<any> = new Subject<any>();

  constructor(private chryConfig: chrysalisConfig, private Store: Store<any>) { }

  
  onwindwoResize(): void {
    if (this.lockState) {
      this.resizeSub.next();
    } else {
      if (!this.isSidebarCollapse()) {
        this.lockState = true;
      }
    }
  }

  ngOnInit() {
    this.sidebarCollapse();
    this.isCollapse = this.Store.select('sidebar');
    this.resizeSub.throttleTime(200).subscribe(() => {
      this.sidebarCollapse();
    });
  }

  private sidebarCollapse() {
    window.innerWidth <= this.chryConfig.layoutSize.widthCollapseSidebar ? this.Store.dispatch({ type: this.chryConfig.COLLAPSED }) : this.Store.dispatch({ type: this.chryConfig.NORMAL });
  }

  private isSidebarCollapse() {
    return window.innerWidth <= this.chryConfig.layoutSize.widthCollapseSidebar;
  }

  onToggleCollapse(event) {
    this.lockState = event;
  }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-sidebar',
  template: "\n    <div class=\"ch-leftMenu\" [ngClass]=\"{barFixed: isFixed}\"><ul class=\"ch-navMenu\" [ngClass]=\"{'menu-collapsed': !(isCollapse | async)}\"><sidebarItem [menuItem]=\"item\" (toggleCollapse)=\"onToggleCollapse($event)\" [isCollapse]=\"isCollapse\" *ngFor=\"let item of menuList\"></sidebarItem></ul></div>\n  ",
  styles: ["\n    .barFixed{position:fixed}.ch-leftMenu{width:200px;height:100%;z-index:4}.ch-navMenu{background:#fff;height:100%;width:200px;transition:width .5s ease;box-shadow:6px 0 6px rgba(0,0,0,.1)}:host /deep/ li{position:relative}:host /deep/ li a.ch-sidebar-list-link{display:block;height:42px;padding-left:18px;text-shadow:none;font-size:13px;text-decoration:none;color:#627789;line-height:42px;white-space:nowrap;overflow:hidden;cursor:pointer}:host /deep/ li a.ch-sidebar-list-link i{margin-right:18px;width:16px;display:inline-block}:host /deep/ li a.ch-sidebar-list-link b{display:block;opacity:1;width:14px;height:14px;line-height:14px;text-shadow:none;font-size:18px;position:absolute;right:10px;top:12px;padding:0;text-align:center;transition:transform .2s linear}:host /deep/ li a.ch-sidebar-list-link:hover{color:#00abff}:host /deep/ .sidebar-childlist{height:0;overflow:hidden;transition:height .6s ease}:host /deep/ .overturnSub>a.ch-sidebar-list-link b{transform:rotate(180deg)}:host /deep/ .menu-collapsed{width:52px}:host /deep/ .menu-collapsed li{width:52px;transition:width .5s ease}:host /deep/ .menu-collapsed li a.ch-sidebar-list-link b,:host /deep/ .menu-collapsed li a.ch-sidebar-list-link span{display:none}:host /deep/ .menu-collapsed li ul.sidebar-childlist{display:none!important}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: chrysalisConfig, },
{type: Store, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menuList': [{ type: Input },],
'isFixed': [{ type: Input },],
'onwindwoResize': [{ type: HostListener, args: ['window:resize', ] },],
};
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
